<template>
  <div class="settings-collections-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Collections</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addCollection"
        variant="primary"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Collection' : 'Add Collection'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitCollection"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group label="Name">
        <b-form-input
          v-model="form.name"
          @keypress="isLetterOrNumber"
          :formatter="formatName"
          maxLength="100"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Data">
        <template v-slot:label>
          <div class="d-flex justify-content-between">
            <span> Data </span>
            <span
              @click="toggleShowType"
              class="hover-pointer text-primary"
              v-if="valuesAreStrings && advancedOptions"
              >{{ showType == "basic" ? "Advanced" : "Basic" }}</span
            >
          </div>
        </template>
        <b-form-textarea
          v-if="showType == 'advanced'"
          v-model="dataJson"
          rows="20"
        ></b-form-textarea>
        <tags-input
          v-if="showType == 'basic'"
          v-model="form.data"
          :listDraggable="true"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import collectionServer from "../../server/collection";
import { mapActions, mapState } from "vuex";
import TagsInput from "../controls/TagsInput.vue";

export default {
  name: "FormBuilderCollectionCrud",
  components: {
    Grid,
    TagsInput
  },
  data() {
    return {
      list: [],
      formId: null,
      form: {
        name: "",
        data: []
      },
      showType: "basic"
    };
  },
  mounted() {
    this.getCollections();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getCollections() {
      this.list = await collectionServer.query();
    },
    async submitCollection() {
      const formData = {
        name: this.form.name,
        data: {
          items: this.form.data
        }
      };
      if (this.formId) {
        await collectionServer.update(this.formId, formData);
      } else {
        await collectionServer.create(formData);
      }
      this.getCollections();
      this.showAlertSuccess();
    },
    addCollection() {
      this.formId = null;
      this.form = {
        name: "",
        data: []
      };
      this.showType = "basic";
      this.$refs["form-modal"].show();
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/[a-zA-Z0-9]/.test(char)) {
        return true;
      } else e.preventDefault();
    },
    formatName(newValue) {
      return newValue.replace(/^\d+/, "");
    },
    toggleShowType() {
      if (this.showType == "basic") this.showType = "advanced";
      else this.showType = "basic";
    },
    checkValuesAreStrings(data) {
      const stringValues = data.filter(item => typeof item == "string");
      return stringValues.length == data.length;
    }
  },
  computed: {
    ...mapState("layout", {
      advancedOptions: state => state.advancedOptions
    }),
    valuesAreStrings() {
      return this.checkValuesAreStrings(this.form.data);
    },
    dataJson: {
      get() {
        return JSON.stringify(this.form.data, undefined, 4);
      },
      set(newValue) {
        this.form.data = JSON.parse(newValue);
      }
    },
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                const form = await collectionServer.get(this.formId);
                this.form = {
                  name: form.name,
                  data: form.data.items
                };
                this.showType = this.checkValuesAreStrings(form.data.items)
                  ? "basic"
                  : "advanced";
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await collectionServer.delete(record.id);
                    this.getCollections();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  }
};
</script>

<style>
.settings-collections-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
